
import { Vue, Component, Prop } from "vue-property-decorator";
import AppTableDesign from "@/components/base/table/AppTableDesign.vue";
import { updateAdvertiserAccesses } from "@/api/revenue";
import { IAdvertisersAccesses } from '@/api/types/revenue';
import { translatePartnerStatus } from "@/utils/translate";
import { NotificationMessage } from "@/utils/notification";
import { showServerError } from "@/utils";
import FormModal from "@/components/base/FormModal.vue";
import { IStatus, ITableFooterButton } from "@/types";

@Component({
    components: { FormModal, AppTableDesign },
})

export default class AccessesTable extends Vue {
    @Prop({ required: true }) items!: IAdvertisersAccesses[];
    @Prop({ default: 100 }) limit!: number;
    @Prop({ default: 0 }) total!: number;
    @Prop({ default: true }) loading!: boolean;
    @Prop({ required: true }) advertiserId!: number;

    selected: IAdvertisersAccesses[] = [];

    headers = [
        { text: 'ID партнёра', sortable: false, value: 'affiliate_id', align: 'center' },
        { text: 'Имя партнёра', sortable: false, value: 'name' },
        { text: 'Почта', sortable: false, value: 'email' },
        { text: 'ID мастера', sortable: false, value: 'master_id' },
        { text: 'Имя мастера', sortable: false, value: 'master_name' },
        { text: 'Статус', sortable: false, value: 'status' },
        { text: 'Аккаунт-менеджер', sortable: false, align: 'center', value: 'manager' },
        { text: 'Действия', sortable: false, align: 'center', value: 'actions' },
    ];

    routes = [
        {
            getParams(item: {affiliate_id: string}): {id: string} {
                return {
                    id: item.affiliate_id!,
                };
            },
            routeParam: 'id',
            routerName: 'affiliate',
            extraRouteParamName: 'affiliate_id',
            slot: 'item.affiliate_id',
            text: 'affiliate_id',
        },
        {
            getParams(item: {master_id: string}): {id: string} {
                return {
                    id: item.master_id!,
                };
            },
            routeParam: 'id',
            slot: 'item.master_id',
            routerName: 'affiliate',
            text: 'master_id',
        },
    ];

    statuses = [
        {
            slot: 'item.status',
            key: 'status',
            translate: this.translateStatus,
        },
    ];

    deletingAccess: { id: number } = {
        id: 0,
    };

    actions = [
        {
            title: 'Удалить',
            color: '#1B1B1D',
            icon: 'SvgTrashWhite',
            isTooltip: true,
            callback: ({ affiliate_id }: {affiliate_id: number}): void => {
                this.deletingAccess.id = affiliate_id;
            },
        },
    ];

    get footerButtons(): ITableFooterButton[] {
        return [
            {
                text: `Удалить`,
                textOfConfirm: 'Подтвердить?',
                color: 'red',
                icon: 'delete',
                action: this.deleteSelectionsAccess,
            },
        ];
    }

    get getDeleteItemText(): { text: string, index: number } {
        const item = this.items.find((item) => item['affiliate_id'] === this.deletingAccess.id);
        const accountName = item?.name;
        return {
            text: `Удалить доступ партнера ${accountName}?`,
            index: 0,
        };
    }

    translateStatus(status: string): IStatus {
        return translatePartnerStatus(status);
    }
    async deleteSelectionsAccess(): Promise<void>{
        try{
            const affiliateIds = this.selected.map(item => item.affiliate_id);
            await updateAdvertiserAccesses({
                id: this.advertiserId,
                affiliates_ids: affiliateIds,
                is_block: false,
            });
            new NotificationMessage(`Изменения сохранены`, 'success' );
            this.selected = [];
            this.$emit('update-table');
        } catch (err) {
            showServerError(err, 'Партнер не может быть удален');
        }
    }
    async deleteOneAccess(): Promise<void> {
        try {
            const index = this.items.findIndex((item) => item['affiliate_id'] === this.deletingAccess.id);
            await updateAdvertiserAccesses({
                id: this.advertiserId,
                affiliates_ids: [this.deletingAccess.id],
                is_block: false,
            });
            this.items.splice(index, 1);
            new NotificationMessage(`Доступ удалён`, 'success' );
            this.deletingAccess.id = 0;
            this.selected = [];
            this.$emit('update-table');
        } catch (err) {
            showServerError(err, 'Партнер не может быть удален');
        }
    }

    submitData(offset: number, limit: number): void {
        this.$emit('update-table', offset, limit);
    }
}
